import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
    Outlet,
} from 'react-router-dom'
import { createBrowserHistory } from 'history'
import JunoAmPage from './Juno/JunoAm/JunoAmPage'
import ClientNewPasswordPage from './Juno/JunoMoney/pages/ClientNewPasswordPage'
import JunoTermsPage from './Juno/JunoMoney/pages/JunoTermsPage'
import JunoPolicyPage from './Juno/JunoMoney/pages/JunoPolicyPage'
import JunoCookiesPage from './Juno/JunoMoney/pages/JunoCookiesPage'
import ProtectedRoute from '../ProtectedRoutes'
import JunoLoginPage from './Juno/JunoMoney/components/global/JunoLogin'
import JuneEverydayBankingPage from './Juno/JunoMoney/pages/JuneEverydayBankingPage'
import JunoContactUs from './Juno/JunoMoney/pages/JunoContactUs'
import JunoMoneyCorporatePage from './Juno/JunoMoney/pages/JunoMoneyCorporatePage'
import JunoMoneyLandingPage from './Juno/JunoMoney/pages/JunoMoneyLandingPage'

import NotFound from './Juno/client/pages/NotFound'
import MaintenancePage from './Juno/JunoMoney/pages/MaintenancePage'
import BulkPayment from './Juno/client/pages/BulkPayment'
import JunoRegistrationPage from './Juno/JunoMoney/pages/JunoRegistrationPage'
import PersonalRegistrationPage from './Juno/JunoMoney/pages/PersonalRegistrationPage'
import BusinessRegistrationPage from './Juno/JunoMoney/pages/BusinessRegistrationPage'
import JncOverview from '../new-ui/pages/JncOverview'
import BalancesPage from '../new-ui/pages/BalancesPage'
import AccountsPage from '../new-ui/pages/AccountsPage'
import TransactionsPage from '../new-ui/pages/TransactionsPage'
import { CryptoAddressPage } from '../new-ui/pages/CryptoAddressPage'
import StatementPage from '../new-ui/pages/StatementPage'
import SingleBalancePage from '../new-ui/pages/SingleBalancePage'
import ProfilePage from '../new-ui/pages/ProfilePage'
import Layout from '../new-ui/Layout/Layout'
import PublicRoute from "../PublicRoute"

const history = createBrowserHistory()
const ClientLayout = () => (
    <Layout>
        <Outlet />
    </Layout>
)

const RoutesList = () => {
    return (
        <Router history={history}>
            <Routes>
                <Route
                    exact
                    path="/juno-management-solutions"
                    element={<PublicRoute component={JunoAmPage} />}
                />
                <Route
                    path="/"
                    element={<PublicRoute component={JunoMoneyLandingPage} />}
                />
                <Route
                    exact
                    path="/login/:id?"
                    element={<PublicRoute component={JunoLoginPage} />}
                />
                <Route
                    exact
                    path="/authorize"
                    element={<PublicRoute component={JunoLoginPage} />}
                />
                <Route
                    exact
                    path="/juno-terms"
                    element={<PublicRoute component={JunoTermsPage} />}
                />
                <Route
                    exact
                    path="/juno-privacy-policy"
                    element={<PublicRoute component={JunoPolicyPage} />}
                />
                <Route
                    exact
                    path="/juno-cookies"
                    element={<PublicRoute component={JunoCookiesPage} />}
                />
                <Route
                    exact
                    path="/maintenance"
                    element={<MaintenancePage />}
                />

                {/* Group client routes under a parent route with the Layout */}
                <Route path="/client" element={<ClientLayout />}>
                    <Route index element={<JncOverview />} />
                    <Route
                        path="transactions"
                        element={
                            <ProtectedRoute component={TransactionsPage} />
                        }
                    />
                    <Route
                        path="accounts"
                        element={<ProtectedRoute component={AccountsPage} />}
                    />
                    <Route
                        path="profile"
                        element={<ProtectedRoute component={ProfilePage} />}
                    />
                    <Route
                        path="balances"
                        element={<ProtectedRoute component={BalancesPage} />}
                    />
                    <Route
                        path="address"
                        element={
                            <ProtectedRoute component={CryptoAddressPage} />
                        }
                    />
                    <Route
                        path="statements"
                        element={<ProtectedRoute component={StatementPage} />}
                    />
                    <Route
                        path="balances/:currency"
                        element={
                            <ProtectedRoute component={SingleBalancePage} />
                        }
                    />
                    <Route
                        path="bulk-payment"
                        element={<ProtectedRoute component={BulkPayment} />}
                    />
                </Route>

                {/* TODO: Will be added later, skipping for current release */}
                {/* <Route
        exact
        path="/juno-banking-services"
        element={<JunoMoneyBankingServicesPage />}
      /> */}
                <Route
                    exact
                    path="/juno-individual"
                    element={
                        <PublicRoute component={JuneEverydayBankingPage} />
                    }
                />
                <Route
                    exact
                    path="/juno-corporate"
                    element={<PublicRoute component={JunoMoneyCorporatePage} />}
                />
                <Route
                    exact
                    path="/client-forgot-password/:token"
                    element={<PublicRoute component={ClientNewPasswordPage} />}
                />

                <Route
                    exact
                    path="/contact-us"
                    element={<PublicRoute component={JunoContactUs} />}
                />
                <Route
                    exact
                    path="/invite-to-register/:whiteLabelId?/personal"
                    element={
                        <PersonalRegistrationPage />
                    }
                />
                <Route
                    exact
                    path="/invite-to-register/:whiteLabelId?/business"
                    element={
                        <BusinessRegistrationPage />
                    }
                />
                <Route
                    exact
                    path="/invite-to-register/:whiteLabelId?"
                    element={<PublicRoute component={JunoRegistrationPage} />}
                />
                <Route exact path="*" element={<NotFound />} />
            </Routes>
        </Router>
    )
}

export default RoutesList
